import styled from "@emotion/styled";
import { css } from "@emotion/react";
import { styled as MuiStyled } from "@mui/material/styles";
import { Paper, Typography, ListItemText } from "@mui/material";

//*************************************************//
//********************Emotion**********************//
export const NavContainerAbsolut = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  max-width: 1200px;
  width: 100%;
  margin: 0 auto;
  display: block;
  z-index: 6;
  ${({ sticky }) =>
    sticky
      ? css`
          display: none;
        `
      : ""}
`;

export const NavContainerSticky = styled.div`
  z-index: 6;
  position: fixed;
  top: -100px;
  height: 100px;
  width: 100%;
  background-color: #ffffff;
  box-shadow: 0 10px 30px -10px rgba(0, 0, 0, 0.25);
  transition: top 250ms ease-in-out;

  svg path {
    fill: black !important;
  }

  ${({ sticky }) =>
    sticky
      ? css`
          top: 0;
          transition: top 250ms ease-in-out;
          ${Menus} {
            a.localSwitcher {
              color: #17479e;
              :hover {
                background-color: #fbfbfc;
              }
            }
          }
          ${ListItem} {
            & .linkName {
              color: #000;
              :hover {
                background-color: #fbfbfc;
              }
            }
          }
        `
      : ""}

  ${({ display }) =>
    display === "flex"
      ? css`
          display: flex;
          align-items: center;
        `
      : css`
          display: none;
        `}
`;

export const NavWrapper = styled.div`
  position: relative;
  margin-top: 20px;
  .MuiDivider-root {
    border-color: #5c74b3;
  }
`;

export const TopNav = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 16px;
`;

export const SocialWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  a {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 35px;
    height: 35px;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.1);
    svg {
      width: 20px;
      height: 20px;
      path {
        fill: #ffffff;
      }
    }
  }
`;

export const LogoWrapper = styled.div`
  position: relative;
  width: 170px;
  overflow: hidden;
  img {
    max-width: 100%;
  }
  ${props =>
    props.sticky
      ? css`
          margin-left: 10px;
        `
      : ""}
`;

export const Nav = styled.nav`
  position: relative;
  max-width: 1200px;
  margin: 0 auto;
  z-index: 2;
  background: rgb(252 252 252 / 0);
  transform: translateZ(1000px);
  transition: all 250ms ease-in-out;

  .panelBackgroundWrapper {
    position: absolute;
    width: 100%;
    top: 100%;
    left: 0;
    border-radius: 10px;
    transform: translateZ(-100px);
    visibility: hidden;
    margin-top: 1px;
    transition: all 250ms ease-in-out;

    .panelBackgroundContainer {
      position: absolute;
      width: 100%;
      top: 0;
      left: 0;
      margin-top: 10px;
      border-radius: 20px;
      overflow: hidden;

      .panelBackground {
        position: absolute;
        top: -100%;
        left: 0;
        width: 100%;
        height: 100%;
        background: #fff;
        display: flex;
        overflow: hidden;
        border-radius: 20px;
        border: 1px solid #e6e6e7;
      }
    }
  }
`;

export const Menus = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-right: 13px;
  .search_language {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  a.localSwitcher,
  .searchIcon {
    height: 44px;
    width: 44px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: Inter, "Open Sans", Roboto, sans-serif !important;
    color: #fff;
    border-radius: 50%;
    cursor: pointer;
    background-color: rgba(255, 255, 255, 0);
    transition: background-color 250ms ease-in-out;
    :hover {
      background-color: rgba(255, 255, 255, 0.15);
    }
  }
`;

export const ListWrapper = styled.ul`
  display: flex;
  align-items: center;
`;

export const ListItem = styled.li`
  display: flex;
  align-items: center;
  font-weight: 500;
  height: 44px;

  width: auto;
  & .linkName {
    border-radius: 30px;
    padding: 0 13px;
    color: #fff;
    display: flex;
    align-items: center;
    width: max-content;
    height: 100%;
    cursor: pointer;
    text-transform: capitalize;
    background-color: rgba(255, 255, 255, 0);
    transition: background-color 250ms ease-in-out;
    :hover {
      background-color: rgba(255, 255, 255, 0.15);
    }
  }

  .panel {
    position: absolute;
    top: 100%;
    left: 0;
    width: 100%;
    will-change: opacity, transform;
    cursor: default;
    transform: translateZ(1000px);
    /*box-shadow: rgba(28, 27, 126, 0.15) 0px -4px 30px -10px;*/
    border-radius: 20px;
    .card {
      display: flex;
      flex-direction: row;
      width: 100%;
      box-sizing: border-box;
      margin-top: 10px;
      border-radius: 20px;
      .linksWrapper {
        box-sizing: border-box;
        padding: 30px;
        position: relative;
      }
    }
  }
`;

export const ListItemSubmenu = styled.li`
  display: inline-block;
  background: rgba(255, 255, 255, 0);
  border-radius: 10px;
  white-space: nowrap;
  transition: background-color 250ms ease-in-out;
  width: 100%;
  a {
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    position: relative;
    width: 100%;
    box-sizing: border-box;
    text-align: left;
    padding: 10px 8px;
  }
  i {
    display: flex;
    align-items: flex-start;
    margin-right: 14px;
    svg {
      width: 30px;
      height: 30px;
    }
  }

  :hover {
    background: rgba(234, 240, 255, 0.8);
    svg {
      width: 30px;
      height: 30px;
      path {
        fill: #17479e;
        stroke: #17479e;
      }
    }
    span.MuiTypography-root {
      color: #17479e;
    }
  }
`;

export const SubMenuWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 30px;
  ul {
    display: flex;
    flex-direction: column;
  }
`;

//***************************************************//
//********************MuiStyled**********************//

export const MuiPaper = MuiStyled(Paper)(({ theme }) => ({
  position: "absolute",
  boxShadow: "0px 34px 40px -10px rgba(0, 0, 0, 0.25)",
  borderRadius: 20,
  overflow: "hidden",
  padding: "30px 20px",
  top: "100%",
  left: -16,
  width: "calc(100% + 32px)",
}));

export const MuiTitleSubmenu = MuiStyled(Typography)(({ theme }) => ({
  display: "inline-block",
  fontWeight: 500,
  fontSize: 14,
  textTransform: "capitalize",
  color: "#808285",
  marginLeft: 10,
  marginBottom: 8,
}));

export const MuiListItemText = MuiStyled(ListItemText)(({ theme }) => ({
  "& span": {
    fontWeight: 500,
    fontSize: 15,
    textTransform: "capitalize",
    color: "#000000",
    lineHeight: "26px",
  },
  "& p": {
    fontWeight: 400,
    fontSize: 12,
    color: "#808285",
    lineHeight: "20px",
  },
}));
